<p-blockUI [blocked]="pageLoading()" />
<app-progress-spinner [enabled]="pageLoading()" />

<div class="header">
  <p-panel [showHeader]="true" header="Filters" [toggleable]="true">
    <form [formGroup]="searchForm">
      <div class="filter-input">
        <label for="logId">{{ 'MONLOG.LABEL.LOG_ID' | translate }}:</label>
        <input type="text" pInputText formControlName="logId" />
      </div>
      <div class="filter-input">
        <label for="date">{{ 'MONLOG.LABEL.DATE' | translate }}:</label>
        <p-datepicker
          formControlName="date"
          dateFormat="yy-mm-dd"
          appendTo="body"
        />
      </div>
      <div class="filter-input">
        <label for="facilityName"
          >{{ 'LOCATION.LABEL.FACILITY_NAME' | translate }}:</label
        >
        <input type="text" pInputText formControlName="facilityName" />
      </div>
      <div class="filter-input">
        <label for="facilityId"
          >{{ 'LOCATION.LABEL.FACILITY_UID' | translate }}:</label
        >
        <input type="text" pInputText formControlName="facilityId" />
      </div>
      <div class="buttons">
        <button
          type="button"
          pButton
          icon="fa fa-search"
          iconPos="left"
          label="{{ 'COMMON.LABEL.BUTTONS.RETRIEVE' | translate }}"
          class="nav-button filter-panel-button"
          (click)="retrieveMonLogs()"
        ></button>
        <button
          type="button"
          pButton
          icon="fa fa-fw fa-eraser"
          iconPos="left"
          label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
          class="nav-button filter-panel-button"
          (click)="clearFilters()"
        ></button>
      </div>
    </form>
  </p-panel>
</div>
<div>
  @if (this.monLogs().length > 0) {
    <p-paginator
      [showFirstLastIcon]="true"
      [showCurrentPageReport]="true"
      [rows]="pageSize"
      (onPageChange)="onPageChange($event)"
      [totalRecords]="totalRecords"
      currentPageReportTemplate="Showing {first}-{last} of {totalRecords}"
      [first]="currentPage * pageSize"
    />
    @for (monLog of monLogs(); track monLog.id) {
      <p-card (click)="onMonLogSelected(monLog)">
        <ng-template #title>
          <div class="mon-log-id">
            <span>{{ monLog.logId }}</span>
            <i class="fa fa-info-circle"></i>
          </div>
        </ng-template>
        <ng-template #subtitle>Status: {{ monLog.logStatus }}</ng-template>
        <div class="card-section">
          <div>
            <p>Facility Name: {{ monLog.facilityName }}</p>
            <p>Facility ID: {{ monLog.facilityUid }}</p>
          </div>
          <div>
            <p>
              Primary Contact: {{ monLog.firstName + ' ' + monLog.lastName }}
            </p>
          </div>
        </div>
      </p-card>
    }
    <p-paginator
      [showFirstLastIcon]="true"
      [showCurrentPageReport]="true"
      [rows]="pageSize"
      (onPageChange)="onPageChange($event)"
      [totalRecords]="totalRecords"
      [first]="currentPage * pageSize"
      currentPageReportTemplate="Showing {first}-{last} of {totalRecords}"
    />
  } @else {
    <p class="empty-results">No Results to display.</p>
  }
</div>
